import React, { useMemo } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { UIState } from '@/model/global/types';
import { TransactionPageView } from '@/pages/wallets/components';

const TransactionPage: React.FC<RouteComponentProps<{ ['0']: string }>> = ({ match }) => {
  const transactionIDParam = match.params['0'];
  const transactionId = useMemo(() => parseInt(transactionIDParam, 10), [transactionIDParam]);
  return (
    <TransactionPageView
      transactionId={transactionId}
      basePath={UIState.WALLETS}
      hideDetailsLink
      data-test="transaction"
    />
  );
};

export default withRouter(TransactionPage);
